/*
  Hide the desktop sticky cart bar once the footer scrolls into view.
  The bar's own scroll handler keeps toggling `is-visible`, so we flag it with
  `is-at-footer` via an IntersectionObserver on the footer; CSS (desktop only)
  overrides the visible state while that flag is set.
*/
(function () {
  function init() {
    var bar = document.querySelector('cart-bar');
    var footer =
      document.querySelector('.site-footer-wrapper') ||
      document.querySelector('footer.site-footer-wrapper') ||
      document.querySelector('.site-footer-wrapper, footer');
    if (!bar || !footer || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(
      function (entries) {
        bar.classList.toggle('is-at-footer', entries[0].isIntersecting);
      },
      { threshold: 0 }
    );
    io.observe(footer);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
